import React from 'react'
import { FormInputSelectAndNavigate } from '../../../../../../../ui/organisms'

export default {
  title: 'How are you financing this project?',
  next: 'projectInfo.projectFinancier',
  component: (props) => <FormInputSelectAndNavigate options={[
    'Fully funded by us',
    'Less than 50% of the project value is financed',
    'Between 50%- 75% of the project value is financed',
    'More than 75% of the project value is financed'
  ]} {...props}/>
}